const messages = {

  rankingInfoText: "Ranking uses our proprietary POTY Algorithm to evaluate your season performance against other players in your division.",
  clutchWinsInfoText: "Clutch Wins shows every game in which the final score was won by 2 points. This could be 21-19 or any game that goes into overtime.",
  strengthOfOpponentInfoText: "Strength of Opponent analyzes CPL's proprietary POTY Score of each opponent you play that season. POTY gives each player a score between 1-100 with 100 being a perfect score. SOO finds the combined POTY Score of all of your opponents divided by the number of games you have played.",
}

export default messages;